<template>
  <el-card>
    <el-row type="flex" justify="space-between">
      <el-col :xl="24" :lg="24" style="position: relative">
        <el-tabs v-model="params.demension">
          <el-tab-pane :label="$t('month-profits::site-pofits::tab_title')" name="1"></el-tab-pane>
          <el-tab-pane :label="$t('month-profits::staff-pofits::tab_title')" name="2"></el-tab-pane>
        </el-tabs>
        <!-- <el-radio-group v-model="params.demension">
          <el-radio-button :label="1">站点利润月报</el-radio-button>
          <el-radio-button :label="2">运营人员利润月报</el-radio-button>
        </el-radio-group> -->
        <div class="date-wrap">
          <label style="width:50px;">{{ $t('month-profits::date') }}</label>
          <el-date-picker
            :appendToBody="false"
            :clearable="false"
            align="right"
            unlink-panels
            class="date-input"
            @change="handlerDateChange"
            v-model="selectMonth"
            :picker-options="pickerOptions"
            type="month"
            placeholder="选择月"
          ></el-date-picker>
        </div>
      </el-col>
      <!-- <el-col :xl="4" :lg="4" style="display:flex;align-items:center;"> -->
      <!-- </el-col> -->
    </el-row>
    <div style="margin-top: 10px;margin-left:16px" v-show="selectedShop.label">
      {{
        params.demension === '1' ? $t('month-profits::site-pofits::name') : $t('month-profits::staff-pofits::name')
      }}：
      <el-button type="text" @click="goBack">{{ selectedShop.label }}</el-button>
    </div>
    <el-row>
      <el-col :lg="24" :md="24" :sm="24" :xl="24">
        <reportTable
          :config="profitTableConfig"
          v-loading="loading"
          ref="reportTable"
          class="databoard-table"
          :style="`height: ${reportHeight};`"
        >
          <p style="color: #666" v-if="params.demension === '1'" slot="other">
            {{ $t('month-profits::site-pofits::tip_sales') }}：{{
              $dataCheck(count.currency, '') + (count.amount || 0)
            }}
            - {{ $t('month-profits::site-pofits::tip_pay') }} ：{{
              $dataCheck(count.currency, '') + (count.cost || 0)
            }}
            = {{ $t('month-profits::site-pofits::tip_profit') }}：{{
              $dataCheck(count.currency, '') + (count.turnover || 0)
            }}
          </p>
          <p style="color: #666" v-else slot="other">
            {{ $t('month-profits::staff-pofits::tip_sales') }}：{{
              $dataCheck(count.currency, '') + (count.amount || 0)
            }}
            - {{ $t('month-profits::staff-pofits::tip_pay') }} ：{{
              $dataCheck(count.currency, '') + (count.cost || 0)
            }}
            = {{ $t('month-profits::staff-pofits::tip_profit') }}：{{
              $dataCheck(count.currency, '') + (count.turnover || 0)
            }}
          </p>
          <el-table-column
            key="shopName"
            :prop="params.demension === '1' ? 'shopName' : 'campaignName'"
            :label="
              params.demension === '1'
                ? $t('month-profits::site-pofits::table_shopName')
                : $t('month-profits::staff-pofits::table_name')
            "
            min-width="150"
            :show-overflow-tooltip="true"
            v-if="!selectedShop.label"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                v-if="scope.row.shopName !== '总计' && scope.row.campaignName !== '总计'"
                @click="toDetail(scope.row)"
              >
                {{ params.demension === '1' ? scope.row.shopName : scope.row.campaignName }}
              </el-button>
              <span v-else>{{ params.demension === '1' ? scope.row.shopName : scope.row.campaignName }}</span>
            </template>
          </el-table-column>
          <el-table-column key="date" prop="date" :label="$t('month-profits::date')" min-width="120" v-else>
            <template slot-scope="scope">
              {{ scope.row.date }}
            </template>
          </el-table-column>
          <el-table-column
            key="sale"
            v-if="params.demension === '1' || selectedShop.label"
            prop="sale"
            :label="$t('month-profits::site-pofits::table_salesNum')"
            min-width="100"
          >
            <template slot-scope="scope">
              {{ $dataCheck(scope.row.sale) }}
            </template>
          </el-table-column>
          <el-table-column
            key="amount"
            prop="amount"
            :label="`${$t('month-profits::site-pofits::table_salesMoney')}(USD)`"
            min-width="150"
          >
            <template slot-scope="scope">{{ $dataCheck(scope.row.amount) }}</template>
          </el-table-column>
          <el-table-column
            key="adCost"
            prop="adCost"
            :label="`${$t('month-profits::site-pofits::table_adcost')}(USD)`"
            min-width="150"
          >
            <template slot-scope="scope">{{ $dataCheck(scope.row.adCost) }}</template>
          </el-table-column>
          <el-table-column
            key="roi"
            v-if="params.demension === '2' && selectedShop.label === ''"
            prop="roi"
            :label="$t('month-profits::staff-pofits::table_roi')"
            min-width="100"
          >
            <template slot-scope="scope">{{ $dataCheck(scope.row.roi) }}</template>
          </el-table-column>
          <el-table-column
            key="proCost"
            prop="proCost"
            :label="`${$t('month-profits::site-pofits::table_proCost')}(USD)`"
            min-width="150"
          >
            <template slot-scope="scope">{{ $dataCheck(scope.row.proCost) }}</template>
          </el-table-column>
          <el-table-column
            key="logisticsCost"
            prop="logisticsCost"
            :label="`${$t('month-profits::site-pofits::table_logisticsCost')}(USD)`"
            min-width="150"
          >
            <template slot-scope="scope">{{ $dataCheck(scope.row.logisticsCost) }}</template>
          </el-table-column>
          <el-table-column
            key="refundAmount"
            prop="refundAmount"
            :label="`${$t('month-profits::site-pofits::table_refundAmount')}(USD)`"
            min-width="150"
          >
            <template slot-scope="scope">{{ $dataCheck(scope.row.refundAmount) }}</template>
          </el-table-column>
          <el-table-column
            key="grossProfit"
            prop="grossProfit"
            :label="
              `${
                params.demension === '1'
                  ? $t('month-profits::site-pofits::table_grossProfit')
                  : $t('month-profits::staff-pofits::table_grossProfit')
              }(USD)`
            "
            min-width="150"
          >
            <template slot-scope="scope">{{ $dataCheck(scope.row.grossProfit) }}</template>
          </el-table-column>
          <el-table-column
            key="grossMargin"
            prop="grossMargin"
            min-width="120"
            :label="
              params.demension === '1'
                ? $t('month-profits::site-pofits::table_grossMargin')
                : $t('month-profits::staff-pofits::table_grossMargin')
            "
          >
            <template slot-scope="scope">{{ $dataCheck(scope.row.grossMargin) }}%</template>
          </el-table-column>
        </reportTable>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import moment from 'moment'
import reportTable from '@/components/data-analysis/table'
import setConfig from './setConfig'
import { getMonthlyProfitCount, getMonthlyProfitTable } from '@/server/data'
export default {
  components: { reportTable },
  mixins: [setConfig],
  data() {
    return {
      selectMonth: moment(),
      pickerOptions: {
        disabledDate: time => {
          return time.getTime() >= Date.parse(new Date())
        }
      },
      reportHeight: '600px',
      loading: false,
      params: {
        month: moment().format('YYYY-MM'),
        demension: '1'
      },
      count: { amount: null, cost: null, turnover: null },
      profitTableConfig: {},
      selectedShop: { label: '', shopId: '' }
    }
  },
  watch: {
    'params.demension': {
      handler() {
        this.selectedShop = { label: '', shopId: '' }
        this.getAllData()
      }
    }
  },
  mounted() {
    this.getAllData()
  },
  methods: {
    moneyCheck(num, cur) {
      if (this.$dataCheck(num) === '--') {
        return '--'
      } else {
        return cur + num
      }
    },
    getAllData() {
      this.getMonthlyProfitCount()
      this.getMonthlyProfitTable()
    },
    async getMonthlyProfitCount() {
      let obj = {
        ...this.params,
        demension: Number(this.params.demension)
      }
      if (this.selectedShop.shopId) obj = { shopId: Number(this.selectedShop.shopId), ...obj }
      const { data } = await getMonthlyProfitCount(obj)
      if (data.code === this.$code) {
        const count = Array.isArray(data.data.datas) ? data.data.datas[0] : []
        if (data.data.datas.length) {
          this.count = count
        }
      }
    },
    async getMonthlyProfitTable() {
      let obj = {
        ...this.params,
        demension: Number(this.params.demension)
      }
      if (this.selectedShop.shopId) obj = { shopId: Number(this.selectedShop.shopId), ...obj }
      if (this.selectedShop.campaignName) obj.campaignName = this.selectedShop.campaignName
      this.loading = true
      const { data } = await getMonthlyProfitTable(obj)
      if (data.code === this.$code) {
        const list = Array.isArray(data.data.datas) && data.data.datas.length > 1 ? data.data.datas : []
        this.profitTableConfig = this.setTableConfig(list)
      }
      this.loading = false
    },
    handlerDateChange(date) {
      this.params.month = moment(date).format('YYYY-MM')
      this.getAllData()
    },
    toDetail(row) {
      if (this.params.demension === '1') {
        this.selectedShop = { shopId: Number(row.shopId), label: row.shopName }
      } else {
        this.selectedShop = { shopId: Number(row.shopId), label: row.campaignName, campaignName: row.campaignName }
      }
      this.getAllData()
    },
    goBack() {
      this.selectedShop = { label: '', shopId: '', campaignName: '' }
      this.getAllData()
    }
  }
}
</script>

<style lang="scss" scoped>
.databoard-table {
  margin-top: 0px;
}
.date-wrap {
  position: absolute;
  right: 24px;
  top: -8px;
  display: flex;
  align-items: center;
}
/deep/.el-tabs__header {
  margin-bottom: 0;
}
</style>
